import type { Theme } from '../../types/theme';

export const figTheme: Theme = {
  id: 'fig',
  name: 'Fig',
  description: 'Modern developer tool with IDE-like aesthetics for terminal enhancement',
  sourceDesignMd: 'https://github.com/VoltAgent/awesome-design-md/blob/main/design-md/fig/DESIGN.md',
  visualKeywords: ['dark', 'IDE-like', 'developer tool', 'terminal', 'modern'],
  colors: {
    background: '#1c1c1e',
    surface: '#2c2c2e',
    surfaceElevated: '#3a3a3c',
    textPrimary: '#ffffff',
    textSecondary: '#98989d',
    textMuted: '#98989d',
    border: '#48484a',
    borderSubtle: '#636366',
    primary: '#ff6b35',
    primaryHover: '#ff8359',
    primaryActive: '#e5551d',
    accent: '#ff6b35',
    onPrimary: '#000000',
    success: '#22c55e',
    warning: '#f59e0b',
    error: '#ef4444',
  },
  typography: {
    headingFont: 'Inter, system-ui, sans-serif',
    bodyFont: 'Inter, system-ui, sans-serif',
    monoFont: 'JetBrains Mono, monospace',
    headingWeight: '600',
    bodyWeight: '400',
    letterSpacingHeading: '-0.02em',
    letterSpacingBody: '0',
  },
  radius: {
    button: '6px',
    card: '8px',
    panel: '8px',
    badge: '4px',
    input: '6px',
  },
  shadow: {
    card: '0 1px 3px rgba(0,0,0,0.1)',
    elevated: '0 4px 12px rgba(0,0,0,0.15)',
    button: '0 1px 2px rgba(0,0,0,0.1)',
    none: 'none',
  },
  layout: {
    maxWidth: '1280px',
    sectionSpacing: '80px',
    cardPadding: '24px',
    navHeight: '64px',
  },
  mood: {
    density: 'high',
    tone: 'technical',
    productFit: [],
    bestFor: [],
    notGoodFor: [],
  },
};
